import { __assign } from "tslib";
// tslint:disable-next-line:max-line-length
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
import { createMailboxesApi, mailboxesRelativePath } from './index';
export var createMailboxesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createMailboxesApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetMailboxes: function () { return createFakeGetResponder(fakeHttp, mailboxesRelativePath); },
        whenAddMailbox: function (dto) {
            return createFakePostResponder(fakeHttp, mailboxesRelativePath)(dto);
        },
        whenUpdateMailbox: function (dto) {
            return createFakePutResponder(fakeHttp, mailboxesRelativePath + "/" + dto.id)({ forwardingAddress: dto.forwardingAddress });
        },
        whenSetDefaultMailbox: function (dto) {
            return createFakePutResponder(fakeHttp, mailboxesRelativePath + "/" + dto.id + "/setDefault")({});
        },
        whenDeleteMailbox: function (dto) {
            return createFakeDeleteResponder(fakeHttp, mailboxesRelativePath + "/" + dto.id);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map